class ComponentCopyUrl extends HTMLElement {
  constructor() {
    super()
    var button = this.querySelector('.copy-url-clipboard');
    var message = document.querySelector('#copy-to-clipboard-message');
    var timeoutId;
    button.addEventListener('click', ()=>{
      if(message){
        navigator.clipboard.writeText(window.location.href).then(() => {
          message.classList.add('show');
          if(timeoutId)
            clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            message.classList.remove('show');
          }, 1500 );
        })               
      }
    })
  }


  
}
customElements.define('copy-url', ComponentCopyUrl);